import { builder } from '../../../common/js/config/index';
import { EndScreenType } from '../lib/end-screen/end-screen-types';

// Here this config will be merge with the default video config
export const inArticleCommonConfig = {
  video: builder.holder({
    isBlurBackground: builder.boolean('video_blur_background', {
      defaultValue: true,
      label: 'Background Blur effect',
      description: 'Display blur background behind the creative'
    }),
    containerBackgroundColor: builder.color('container_background_color', {
      defaultValue: '#ffffff',
      label: 'Container Background Color',
      description:
        'Container background color behind the creative when the blur is deactivated'
    })
  }),
  controls: builder.holder({
    layout: builder.holder({
      canDisplayResponsiveControls: builder.boolean(
        'can_display_responsive_controls',
        { defaultValue: true }
      )
    }),
    responsiveBorderHidden: builder.boolean('responsive_border_hidden', {
      defaultValue: true
    }),
    showProgressBar: builder.boolean('show_progress_bar', {
      defaultValue: false
    })
  }),
  endScreen: builder.holder({
    ctaOverlay: builder.boolean('end_screen_cta_overlay', {
      defaultValue: true
    }),
    allowListType: builder.arrayString('end_screen_allow_list_type', {
      defaultValue: [
        EndScreenType.DEFAULT,
        EndScreenType.IMAGE,
        EndScreenType.HTML,
        EndScreenType.IFRAME
      ]
    })
  }),
  optOut: builder.holder({
    hide: builder.boolean('hide_opt_out', {
      defaultValue: false,
      description: 'Hide opt out ONLY IF display vast icon (adchoices)'
    }),
    closeAdOnClick: builder.boolean('close_ad_on_optout_click', {
      defaultValue: false,
      description:
        'Close the ad when the user clicks on the opt-out link. If false, the ad will not be closed.'
    })
  })
};
